module.exports = __webpack_public_path__ + "img/c03_unitscout_Normal_ua.dbcd77db.webp";